import { render, staticRenderFns } from "./riskWarnRuleSetting.vue?vue&type=template&id=b73ee4b4&scoped=true"
import script from "./riskWarnRuleSetting.vue?vue&type=script&lang=js"
export * from "./riskWarnRuleSetting.vue?vue&type=script&lang=js"
import style0 from "./riskWarnRuleSetting.vue?vue&type=style&index=0&id=b73ee4b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73ee4b4",
  null
  
)

export default component.exports